import template from './properties-list.html'
import css from './properties-list.css'
import { PropertiesListController } from './properties-list.controller.js'

export const PropertiesListComponent = {
  template: template,
  controller: PropertiesListController,
  controllerAs: 'PropertiesListController',
  bindings: {
    title: '@',
    cssClass: '@',
    items: '='
  }
}


/*
Component Bindings :

1. '=' Two-way data binding. This means that if you update that variable in your component scope, the change will be reflected on the parent scope;

2. '<' One-way bindings when we just want to read a value from a parent scope and not update it;

3. '@' This is for string parameters;

4. '&' This is for callbacks in case your component needs to output something to its parent scope.

*/



// WEBPACK FOOTER //
// ./src/client/common/uiComponents/PropertiesList/properties-list.component.js